export default "Lad eleverne forme forskellige ansigtsudtryk med modellervoks på en skabelon af et hoved – prøv at forme forskellige følelser.";